import Colors from "../../../../theme/colors";

export default {
  container: {
    borderRadius: "12px",
    // margin: "10px 20px 70px 10px",
    minHeight: "570px",
    background: "#FFFFFF",
  },
  topContainer: {},
  formRow: {
    display: "flex",
    marginBottom: "1.5rem",
    flex: 1,
    gap: 15,
  },
  item: {
    flex: "1 1 5%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    cursor: "pointer",
  },
  longItem: {
    flex: "1 1 41%",
  },
  mediumItem: {
    flex: "1 1 28%",
  },
  smallItem: {
    flex: "1 1 18%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  addLink: {
    color: "#183053",
    fontSize: "16px",
    fontWeight: "500",
    cursor: "pointer",
  },
  defaultAddress: {
    color: "#183053",
    fontSize: "16px",
    fontWeight: "500",
    textDecoration: "underline",
    cursor: "pointer",
  },
  main: {
    margin: "3rem 0 0.5rem 0",
  },
  heading: {
    color: "#8C8C8C",
    fontSize: 20,
  },
  headingBox: {
    marginLeft: 30,
    marginTop: 40,
  },
  mainContainer: {
    marginTop: 10,
    paddingBottom: 40,
  },
  subContainer: {
    padding: "2rem",
  },
  familyIdStyle: {
    marginRight: 30,
    marginTop: -30,
    color: "#043D90",
    display: "flex",
    justifyContent: "flex-end",
    flexDirection: "row",
  },
  submitButton: {
    backgroundColor: "#043D90",
    width: "178px",
    height: "40px",
    marginTop: 30,
  },
  cancelButton: {
    backgroundColor: Colors.white,
    border: `1px solid ${Colors.midnightBlue}`,
    color: Colors.midnightBlue,
    marginLeft: "210px",
    marginTop: -66,
    height: "40px",
    width: "178px",
  },
  memberHeader: {
    display: "flex",
    flexDirection: "row-reverse",
    flex: 1,
    gap: 25,
    marginTop: "20px",
    marginBottom: "-50px",
  },
  addressText: {
    color: "#8C8C8C",
    fontSize: "20px",
    marginTop: "10px",
  },
  addressForm: {
    marginTop: "30px",
    flexGrow: 1,
  },
  divider: {
    display: "flex",
    width: "100%",
    paddingTop: "20px",
  },
};
